import { useMemo } from 'react';

import { useFlightDeckContext } from '@atlassiansox/flight-deck-frontend-client';

import { FD_CLIENT_FETCH_PROPS, type FlightDeckConfig } from '../../../hydrator-config-client';
import { type CreateActivityClient, createActivityClient } from '../../index';

export const useActivityClient: CreateActivityClient = (version, product, logger, baseUrl) => {
	const { getArtifact } = useFlightDeckContext();

	return useMemo(
		() =>
			createActivityClient(
				version,
				product,
				logger,
				baseUrl,
				// If the rw-client is wrapped in a FD provider, use the provided fetch function
				getArtifact
					? () =>
							getArtifact<FlightDeckConfig>(
								FD_CLIENT_FETCH_PROPS.name,
								FD_CLIENT_FETCH_PROPS.dimensions,
							)
					: undefined,
			),
		[version, product, logger, baseUrl, getArtifact],
	);
};
